export const SEARCH_BAR_INLINE_SIZE = '450px';